import { Table } from "@components/Legal/legalStyles";
import React from "react";

const DEFINITIONS = [
  ["We, Us, Our", `The nonprofit entity Every.org`],
  ["the Site", `www.every.org, giveli.st, all Every.org mobile apps`],
  ["the Services", `The services offered through the Site`],
  [
    "Every.org",
    `Just to clarify: when we are talking about the nonprofit entity called Every.org, we say “we,” “us,” “our,” or just “Every.org”.
  However, when we are discussing our website (www.every.org) or one of our mobile apps, we say the “Site”`,
  ],
  [
    "Support",
    "To Donate (to Every.org), usually by making a gift in support of a Nonprofit",
  ],
  [
    "Follow",
    "A connection you can make with a with a nonprofit, cause, or other Person on the Site",
  ],
  [
    "Nonprofit",
    "The catch-all term we use for the various forms of charitable entities such as and other Donation-recipients listed on our Site",
  ],
  [
    "International Nonprofit",
    "A Nonprofit that typically has not received a determination of its charitable status from the Internal Revenue Service (“IRS”), and is based outside the US.",
  ],
  ["People/Person", "Anyone that uses the Site"],
  ["Giver/Supporter", "Anyone who uses the Site to Donate"],
  [
    "Cause",
    `This is how we categorize nonprofits focusing on different issue areas, such as "Environment"`,
  ],
  ["Terms", "This binding agreement, the Every.org Terms of Use"],
  [
    "UGC",
    "User-Generated Content, any content created by you that you publicly post on the Site, including, for example, comments.",
  ],
  ["Donate", "To send money to Every.org through the Site"],
  ["Donation", "The actual money Donated"],
  [
    "Join",
    "Feature to signal that your donation was motivated by another donation",
  ],
  ["One-Time Donation", "A Donation that occurs only once (obviously)"],
  ["Recurring Donation", "A donation you set up to repeat on a regular basis"],
  [
    "Distribution",
    "Payments made from Every.org to a Nonprofit, either through a third-party nonprofit partner or directly, as a result of Donations.",
  ],
  [
    "Direct Distribution",
    "Distributions made directly from Every.org to a Nonprofit, without the use of a third-party nonprofit partner.",
  ],
];

export const DefinitionTable: React.FCC = () => {
  return (
    <Table>
      <thead>
        <tr>
          <th>
            <h2>Term</h2>
          </th>
          <th>
            <h2>Definition</h2>
          </th>
        </tr>
      </thead>
      <tbody>
        {DEFINITIONS.map((x, i) => (
          <tr key={i}>
            <th>{x[0]}</th>
            <td>{x[1]}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
